<!--
    描述：提现账户设置 --- 基本表单信息
    时间：2020-12-29
    Created by ws
-->
<template>
    <div>
        <el-form
            ref="accountForm"
            :model="accountForm"
            :rules="accountRules"
            label-width="180px"
        >
            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业名称：" prop="sname" required>
                        <el-input disabled v-model="accountForm.sname"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="统一社会信用代码：" prop="code" required>
                        <el-input disabled v-model="accountForm.code"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="法定代表人姓名：" prop="legaler" required>
                        <el-input disabled v-model="accountForm.legaler"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法定代表人身份证号：" prop="idCard" required>
                        <el-input disabled v-model="accountForm.idCard"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="法定代表人手机号：" prop="legalPhone" required>
                        <el-input disabled v-model="accountForm.legalPhone"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开户行：" prop="bank">
                        <el-select v-model="accountForm.bank" :disabled="isDisabled" clearable>
                            <el-option
                                v-for="(m, n) in khh"
                                :key="'khh' + n"
                                :label="m.sname"
                                :value="m.value"
                            ></el-option>
                        </el-select>
                        <!-- <el-input
                            :disabled="isDisabled"
                            v-model="accountForm.bank"
                        ></el-input> -->
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="对公账户：" prop="account">
                        <el-input
                            :disabled="isDisabled"
                            v-model="accountForm.account"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开户行支行名称：" prop="branchBank">
                        <el-input
                            :disabled="isDisabled"
                            v-model="accountForm.branchBank"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="支付行号：" prop="payNo">
                        <el-input
                            :disabled="isDisabled"
                            v-model="accountForm.payNo"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-form-item label="营业执照：" required>
                <div class="upload-flex">
                    <upload
                        ref="codeUpload"
                        tableName="operate_account"
                        assortment="code"
                        :mode="picMode(1)"
                        listType="picture-card"
                        :aid="accountForm.memberId"
                        :maxNum="1"
                        :hideTip="true"
                        :isDisabled="picDisabled(1)"
                    ></upload>
                    <el-tag
                        size="small"
                        type="info"
                        v-if="isCheck === 0 && accountForm.id"
                        >审核中</el-tag
                    >
                    <el-tag
                        size="small"
                        type="success"
                        v-if="isCheck === 1 && accountForm.id"
                        >√ 已通过认证</el-tag
                    >
                    <el-tag
                        size="small"
                        type="danger"
                        v-if="isCheck === 2 && accountForm.id"
                        >不通过</el-tag
                    >
                </div>
            </el-form-item>
            <el-form-item label="法人身份证原件：" required>
                <div class="flex">
                    <upload
                        ref="idCardZ"
                        listType="picture-card"
                        tableName="operate_account"
                        assortment="idCardZ"
                        :mode="picMode(2)"
                        :needRefresh="false"
                        :isDisabled="picDisabled(2)"
                        :maxNum="1"
                        msg="idCardZ"
                        :aid="accountForm.memberId"
                        :acceptType="[
                            'gif',
                            'jpg',
                            'jpeg',
                            'png',
                            'bmp',
                            'GIF',
                            'JPG',
                            'PNG',
                        ]"
                        :hideTip="false"
                    ></upload>
                    <upload
                        ref="idCardF"
                        listType="picture-card"
                        tableName="operate_account"
                        assortment="idCardF"
                        :mode="picMode(2)"
                        :needRefresh="false"
                        :isDisabled="picDisabled(2)"
                        :maxNum="1"
                        class="ml10"
                        :aid="accountForm.memberId"
                        :acceptType="[
                            'gif',
                            'jpg',
                            'jpeg',
                            'png',
                            'bmp',
                            'GIF',
                            'JPG',
                            'PNG',
                        ]"
                        msg="idCardF"
                        :hideTip="false"
                    ></upload>
                </div>
                <p>温馨提示：上传文件不超过1M，扫描件或复印件。格式为JPG\JPEG\PNG</p>
            </el-form-item> -->
        </el-form>
    </div>
</template>

<script>
import upload from "./account-upload";
import { dateFormat } from "utils/tools";

import {
    sendVerificationCode,
    selectDeptByUserId,
    saveAccount,
    setCompanyInfo,
    saveApplyRecord,
    setApplyRecord,
    pictureCollect,
} from "api/modules/paymentSettlement";
import { deleteFile_pay } from "api/modules/upload";
import { mapState } from "vuex";

export default {
    components: {
        upload,
    },
    props: {
        // 基本信息
        baseInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },

        // 是否可编辑
        disabled: {
            type: Boolean,
            default: false,
        },

        // 企业ID
        bizUserid: {
            type: String,
            default: "",
        },

        // 会员ID
        memberId: {
            type: String,
            default: "",
        },

        mode: {
            type: String,
            default: "add",
        },

        // 审核状态
        checkState: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            accountForm: {
                sname: "",
                code: "",
                legaler: "",
                idCard: "",
                legalPhone: "",
                bank: "",
                account: "",
                branchBank: "",
                payNo: "",
            },
            accountRules: {
                bank: [
                    {
                        required: true,
                        message: "开户行不能为空",
                        trigger: "change",
                        // trigger: "blur",
                    },
                    // {
                    //     pattern: /^[\u4E00-\u9FA5]+$/,
                    //     message: "请输入中文！",
                    //     trigger: "blur",
                    // },
                ],
                account: [
                    {
                        required: true,
                        message: "对公账户不能为空",
                        trigger: "blur",
                    },
                    {
                        // pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,
                        pattern: /^[0-9]{12,24}$/,
                        message: "请输入12-24位数字！",
                        trigger: "blur",
                    },
                ],
                branchBank: [
                    {
                        required: true,
                        message: "开户支行名称不能为空",
                        trigger: "blur",
                    },
                    {
                        pattern: /^[\u4E00-\u9FA5]+$/,
                        message: "请输入中文！",
                        trigger: "blur",
                    },
                ],
                payNo: [
                    {
                        required: true,
                        message: "支付行号不能为空",
                        trigger: "blur",
                    },
                    {
                        pattern: /^[0-9]{12,24}$/,
                        message: "请输入12-24位数字！",
                        trigger: "blur",
                    },
                ],
            },
            accountId: "", // 数据库存记录主键ID
        };
    },
    created() {
        console.log(this.bizUserid);
        // 初始赋值
        if (this.baseInfo.list && this.baseInfo.list.length > 0) {
            this.accountForm = Object.assign({}, this.baseInfo);
        } else {
            this.accountForm.sname = this.baseInfo.sname;
            this.accountForm.code = this.baseInfo.creditCode;
            this.accountForm.legaler = this.baseInfo.legal;
            this.accountForm.idCard = this.baseInfo.legalNo;
            this.accountForm.legalPhone = this.baseInfo.legalPhone;
            this.accountForm.memberId = this.memberId;
            this.accountForm.bizUserId = this.bizUserid;
        }
    },
    mounted() {
        if (this.baseInfo.list && this.baseInfo.list.length > 0) {
            // 查看附件状态  如果为 2 则删除对应附件
            this.$nextTick(() => {
                setTimeout(() => {
                    this.deleteFile(1, "codeUpload");
                    this.deleteFile(2, "idCardZ");
                    this.deleteFile(2, "idCardF");
                }, 500);
            });
        }
    },
    methods: {
        // 删除附件
        deleteFile(type, obj) {
            let _fileObj = this.baseInfo.list.find((x) => x.type === type);
            let _file = this.$refs[obj].fileList;
            if (_fileObj && _fileObj.state === 2 && _file.length > 0) {
                deleteFile_pay({ id: _file[0].id })
                    .then((res) => {
                        this.$refs[obj].$refs.upload.uploadFiles = [];
                        this.$refs[obj].fileList = [];
                    })
                    .catch((err) => {});
            }
        },

        // 保存
        doSubmit(isEdit, fileObj) {
            let status = false;
            let that = this;
            let length_1 =
                this.$refs.codeUpload.addList.length === 0 &&
                this.$refs.codeUpload.fileList.length === 0;
            let length_2 =
                this.$refs.idCardZ.addList.length === 0 &&
                this.$refs.idCardZ.fileList.length === 0;
            let length_3 =
                this.$refs.idCardF.addList.length === 0 &&
                this.$refs.idCardF.fileList.length === 0;

            // 表单验证
            this.$refs.accountForm.validate((valid) => {
                if (valid) {
                    if (length_1 || length_2 || length_3) {
                        this.$message.warning("请上传附件！");
                        return status;
                    }

                    status = true;
                    let params = Object.assign({}, this.accountForm);
                    // 设置开户行中文
                    let _obj = this.khh.find(x => x.value === params.bank)
                    _obj ? params.bankName = _obj.sname : ''

                    if (isEdit) {
                        delete params.list;
                        delete params.id;
                    }

                    // 第一步 设置企业信息(调通联保存)
                    if (!fileObj) {
                        that.onSetCompanyInfo(params);
                    }
                } else {
                    this.$message.warning("请完善必填信息！");
                }
            });
            return status;
        },

        // 图片是否可编辑
        picMode(curType) {
            let mode = "add";
            if (this.baseInfo.list) {
                let _typeObj = this.baseInfo.list.find((x) => x.type === curType);
                if (_typeObj && _typeObj.state === 2) {
                    mode = "edit";
                } else if (_typeObj) {
                    mode = "view";
                }
            }
            return mode;
        },

        // 设置企业信息 --- 通联
        onSetCompanyInfo(params, status) {
            let that = this;
            setCompanyInfo(params)
                .then((res) => {
                    // console.log(res)
                    // 第二步 --- 本地保存
                    that.onSaveAccount(params);
                })
                .catch((err) => {
                    // console.log(err)
                    this.$emit("on-error", 1);
                    // return false
                    // console.log(err)
                });
        },

        // 保存收款账户 --- 本地
        onSaveAccount(params) {
            params.tiedPhone = "";
            params.memberType = 2; // 企业会员
            let that = this;

            let fileObj = {
                file1: this.$refs.codeUpload.addList[0],
                file2: this.$refs.idCardZ.addList[0],
                file3: this.$refs.idCardF.addList[0],
            };
            saveAccount(params)
                .then((res) => {
                    // console.log('``````````第二步 --- 本地保存')
                    // console.log(res);
                    that.accountId = res.data.id;
                    that.$emit("setAccountId", res.data.id);
                    this.$emit("setFileList", fileObj);
                    this.$emit("setFileId", res.data.memberId);
                    // 保存通联记录
                    that.onSaveApplyRecord(0);

                    // 保存图片 --- 本地
                    // that.saveImgs(res.data.memberId, 1);
                    // that.saveImgs(res.data.memberId, 8);
                    // that.saveImgs(res.data.memberId, 9);

                    // 保存记录
                    that.onSaveApplyRecord(1);
                    that.onSaveApplyRecord(2);
                })
                .catch((err) => {
                    // return false
                    // console.log(err)
                });
        },

        // 保存通联接口调用记录
        onSaveApplyRecord(type) {
            // type 0：设置企业信息1：影印件采集----营业执照2：影印件采集----身份证正面影印件采集----身份证反面电子签约协议
            let params = {
                accountId: this.accountId,
                type: type,
            };
            saveApplyRecord(params)
                .then((res) => {
                    // console.log('``````````第三步 存记录')
                    // console.log(res)
                    // return true
                })
                .catch((err) => {
                    // return false
                    // console.log(err)
                });
        },

        // 保存图片
        saveImgs(id, type) {
            switch (type) {
                case 1:
                    this.$refs.codeUpload.fileSend(id);
                    break;
                case 8:
                    this.$refs.idCardZ.fileSend(id);
                    break;
                case 9:
                    this.$refs.idCardF.fileSend(id);
                    break;
            }
        },

        // 影印件上传审核 --- 传通联
        onPictureCollect(type, list, memberId) {
            let status = true;
            let that = this;
            if (!list) {
                return;
            }

            // 上传服务器
            that.saveImgs(memberId, type);

            let formData = new FormData();
            formData.append("file", list);
            formData.append("path", dateFormat("yyyy-mm-dd"));
            formData.append("output", "json");
            formData.append("bizUserId", this.bizUserid);
            formData.append("picType", type);

            let params = {
                accountId: this.accountId,
                type: type,
            };

            pictureCollect(formData)
                .then((d) => {
                    // console.log(d)
                })
                .catch((err) => {
                    // console.log(err)
                    // 设置为 2
                    setApplyRecord(params)
                        .then((res) => {})
                        .catch((err) => {});
                });
        },

        // 上传影映件
        uploadPictures(obj, memberId) {
            // 保存图片 --- 传通联
            this.onPictureCollect(1, obj.file1, memberId);
            this.onPictureCollect(8, obj.file2, memberId);
            this.onPictureCollect(9, obj.file3, memberId);
        },

        // 图片是否可编辑
        picDisabled(type) {
            if (this.mode === "view") {
                return true;
            }
            let _list = this.baseInfo.list;
            let status = false;
            if (_list && _list.length > 0) {
                let _type = _list.find((x) => x.type === type);

                if (_type && _type.state !== 2) {
                    status = true;
                }
            }

            return status;
        },
    },
    computed: {
        ...mapState("dict", {
            khh: (state) => state.projectDict.khh,
        }),
        checkObj() {
            let obj = {
                text: "",
                type: "info",
            };
            if (this.checkState === 0) {
                obj.text = "审核中";
            } else if (this / this.checkState === 1) {
                obj.text = "已通过验证";
                obj.type = "success";
            } else {
                obj.text = "不通过";
                obj.type = "error";
            }
            return obj;
        },

        // 是否可编辑
        isDisabled() {
            let status = false;
            if (this.mode === "view") {
                status = true;
            } else {
                let _state = this.checkState === 1 || this.checkState === 0;
                status = _state && this.disabled;
            }
            return status;
        },

        // 是否通过了
        isCheck() {
            if (!this.baseInfo.list) {
                return 2;
            }
            let status = this.checkState;
            let pic1 = this.baseInfo.list.find((x) => x.type === 1);
            let pic2 = this.baseInfo.list.find((x) => x.type === 2);
            let agree = this.baseInfo.list.find((x) => x.type === 3);

            let _failed = this.baseInfo.list.find(x => x.state === 2)
            if (
                status === 1 &&
                pic1 &&
                pic1.state === 1 &&
                pic2 &&
                pic2.state === 1 &&
                agree.state === 1
            ) {
                return 1;
            } else if (_failed) {
                return 2;
            } else {
                return 0;
            }
        },
    },
};
</script>

<style scoped lang="less">
.upload-flex {
    display: flex;
    justify-content: space-between;
}
</style>
